export interface GetDistanceProps {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}
export const getDistanceBetweenPoints = ({ x1, y1, x2, y2 }: GetDistanceProps) => {
  const dx = Math.abs(x2 - x1);
  const dy = Math.abs(y2 - y1);
  return Math.sqrt(dx * dx + dy * dy);
};
